import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"mall, store, shop, business"} maskId="square-filled-radius-0-stroke-1-IconMall"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM16.5 19V11.5H12.5V19H16.5ZM11.5 19V11.5H7.5V19H11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMall;
